export default "__VITE_ASSET__Bcg7Ti$9__"